var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySpaceNoItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 246,
    viewBox: "0 0 327 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.643 0.466401C195.299 4.94832 201.996 47.1398 224.742 69.6115C247.785 92.3784 296.099 98.3303 295.483 130.721C294.864 163.213 246.995 168.244 222.459 189.548C201.274 207.941 191.65 243.576 163.643 245.189C135.32 246.82 119.08 215.321 97.6417 196.735C73.1938 175.541 34.9365 162.908 31.6043 130.721C28.1846 97.6886 58.7554 72.7771 82.3948 49.4572C105.801 26.3676 131.093 -4.14228 163.643 0.466401Z",
    fill: "url(#paint0_linear_19952_303484)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_19952_303484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.828 40.2662C194.058 25.7354 243.272 69.7154 258.108 125.087C269.2 166.483 224.051 192.424 183.51 203.287C140.544 214.8 84.4042 218.652 72.6491 174.781C57.3101 117.535 83.7634 55.2887 139.828 40.2662Z",
    fill: "url(#paint1_linear_19952_303484)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.142 168.042C133.576 168.042 113.662 147.709 113.662 122.625C113.662 97.5415 133.576 77.2085 158.142 77.2085C182.708 77.2085 202.621 97.5415 202.621 122.625C202.621 147.709 182.708 168.042 158.142 168.042ZM158.142 158.959C167.579 158.959 176.63 155.131 183.303 148.317C189.977 141.503 193.726 132.261 193.726 122.625C193.726 112.989 189.977 103.747 183.303 96.9336C176.63 90.1198 167.579 86.2918 158.142 86.2918C148.704 86.2918 139.654 90.1198 132.98 96.9336C126.307 103.747 122.558 112.989 122.558 122.625C122.558 132.261 126.307 141.503 132.98 148.317C139.654 155.131 148.704 158.959 158.142 158.959ZM153.694 99.9168H162.59V109H153.694V99.9168ZM153.694 118.083H162.59V145.334H153.694V118.083Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_19952_303484",
    x: 60.3486,
    y: 33.4619,
    width: 207.464,
    height: 189.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19952_303484"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_19952_303484",
    result: "effect2_dropShadow_19952_303484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_19952_303484",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19952_303484",
    x1: 31.3408,
    y1: 122.625,
    x2: 295.488,
    y2: 122.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19952_303484",
    x1: 65.3612,
    y1: 147.582,
    x2: 250.82,
    y2: 97.8885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySpaceNoItems);
export default __webpack_public_path__ + "static/media/emptySpaceNoItems.6e9c5fc50985fd2ef28b306410b359ad.svg";
export { ForwardRef as ReactComponent };